import { Modal, Box, Button, Textarea, TextInput } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import { UserTypeContext } from "../../App";
import { DepartmentLocation } from "../singleSelect/DepartmentLocation";
import DepartmentSelect from "../singleSelect/DepartmentSelect";
import { useFetchEmployeesData } from "../../hooks/team/hooks";

export default function EditHardwareModal({
  opened,
  close,
  loader,
  form,
  branchID,
  editMethod,
}) {
  const userType = useContext(UserTypeContext).userType;
  const { employees } = useFetchEmployeesData();
  // const [attachedUuser, setAttachedUser] = useState("");
  const [attachedIndex, setAttachedIndex] = useState(0)
  useEffect(() => {
    // alert(JSON.stringify(employees));

  }, [])
  return (
    <>
      <Modal
        opened={opened}
        onClose={() => { }}
        centered
        withCloseButton={true}
        title="Edit Hardware Device"
      >
        {/* <div style={{ width: 250 }}>
          <code>
            {JSON.stringify(employees[0])}
          </code>
        </div> */}
        <form
          onSubmit={form.onSubmit((values, e) => editMethod(values, e))}
          className="w-full"
        >
          <Box>
            <TextInput
              withAsterisk
              label="Device ID"
              size="lg"
              readOnly
              placeholder="Enter device ID"
              radius={4}
              styles={(theme) => ({
                label: {
                  paddingBottom: 4,
                  fontSize: 16,
                  marginTop: 14,
                  fontWeight: 500,
                },
                input: {
                  borderWidth: 1,
                  backgroundColor: "#e2e3e5",
                  fontSize: 14,
                  "&:focus-within": {
                    borderColor: theme.colors.luchiPrimary[0],
                  },
                },
              })}
              {...form.getInputProps("deviceid")}
            />
            {/*  */}
            <h3 style={{ marginTop: 10 }}>Who is the door connected? </h3>
            <div style={{ width: "96%", maxHeight: 250, overflowY: "auto", margin: "10px auto" }}>
              <a href="#attach" onClick={() => {
                setAttachedIndex(0)
                // setAttachedUser("Public Door")
                window.sessionStorage.setItem("attached_to", "Public Door")
              }} style={{ display: "inline-block", width: "auto", backgroundColor: attachedIndex === 0 ? "#3EA7AE" : "#fff", border: "0.5px solid #000", color: attachedIndex === 0 ? "#fff" : "#3EA7AE", padding: 10, marginRight: 5, marginBottom: 5, borderRadius: 5, }}>
                Public Door
              </a>
              {
                !employees ?
                  <></>
                  :
                  employees.map((o, i) => {
                    return (
                      <a href="#attach" onClick={() => {
                        setAttachedIndex(i + 1);
                        // setAttachedUser(o.name)
                        window.sessionStorage.setItem("attached_to", o.name)
                      }} style={{ display: "inline-block", width: "auto", backgroundColor: attachedIndex === i + 1 ? "#3EA7AE" : "#fff", border: "0.5px solid #000", color: attachedIndex === i + 1 ? "#fff" : "#3EA7AE", padding: 10, marginRight: 5, marginBottom: 5, borderRadius: 5, }} key={i}>
                        {o.name}
                      </a>
                    )
                  })
              }
            </div>
            <TextInput
              withAsterisk
              label="Device Name"
              size="lg"
              placeholder="Specific name for device"
              radius={4}
              styles={(theme) => ({
                label: {
                  paddingBottom: 4,
                  fontSize: 16,
                  marginTop: 14,
                  fontWeight: 500,
                },
                input: {
                  borderWidth: 1,
                  fontSize: 14,
                  "&:focus-within": {
                    borderColor: theme.colors.luchiPrimary[0],
                  },
                },
              })}
              {...form.getInputProps("name")}
            />
            <Textarea
              withAsterisk
              label="Description"
              size="md"
              placeholder="Eg: Device for marketing department"
              radius={4}
              styles={(theme) => ({
                label: {
                  paddingBottom: 4,
                  fontSize: 16,
                  marginTop: 14,
                  fontWeight: 500,
                },
                input: {
                  borderWidth: 1,
                  fontSize: 14,
                  "&:focus-within": {
                    borderColor: theme.colors.luchiPrimary[0],
                  },
                },
              })}
              {...form.getInputProps("description")}
            />
          </Box>
          <Box my={14}>
            {userType === "super_admin" && <DepartmentLocation form={form} />}
          </Box>
          <Box mb={20}>
            <DepartmentSelect form={form} branchID={branchID} />
          </Box>
          <Box className="flex space-x-3">
            <Button
              onClick={close}
              fullWidth
              variant="outline"
              className="text-sm font-medium text-red-900 capitalize border-red-800 "
              type="button"
            >
              cancel
            </Button>
            <Button
              fullWidth
              loading={loader}
              loaderPosition="right"
              color="yellow"
              variant="white"
              className="bg-luchiPrimary text-sm font-medium text-white capitalize "
              type="submit"
            >
              update
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
}
